
<app-table [data]="data" [tableInfo]="tableInfo"></app-table>


<!--<p-sidebar [(visible)]="sidebarVisible" position="right" (onHide)="sidebarVisible = null" [style]="{width: '60vw'}" #sidebar>
	<app-shipping-errors-form *ngIf="sidebarVisible" (onSubmit)="onSubmit($event)"></app-shipping-errors-form>
</p-sidebar>-->


<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{width: '60vw'}">
	<app-shipping-errors-form *ngIf="sidebarVisible" (onSubmit)="onSubmit()"></app-shipping-errors-form>
</p-sidebar>
<!--<app-shipping-errors-form></app-shipping-errors-form>-->
